import { timeoutInit } from "../../../util";

/**
 * How long the PTI views wait on a read that fronts the APTA API.
 *
 * `fetchApi`'s 10s default is sized for our own endpoints. These are not ours:
 * every one of them can miss the Redis cache and fall through to APTA, and on
 * 2026-09-10 that produced a wall of aborts — /api/pti/locations-stats had a
 * p50 of 9.97s, i.e. it essentially never returned before the browser gave up,
 * and a player who had just linked their APTA number was shown the engine's
 * own abort wording instead of their stats.
 *
 * 45s is chosen against the server, which deliberately outlives the browser so
 * the abandoned request still populates the cache (see the note on
 * LOOKUP_TIMEOUT in webby-server integrations/apta/api.service.ts). Waiting
 * roughly as long as the lookup deadline means a cold read now usually lands,
 * and when the server does give up first we surface its real error rather than
 * an abort. It stays bounded because a spinner is not free: the far more
 * common case is a cache hit in well under a second.
 */
export const APTA_READ_TIMEOUT_MS = 45_000;

/** `RequestInit` for a PTI read that may fall through to APTA. */
export function aptaReadInit(): RequestInit {
    return timeoutInit(APTA_READ_TIMEOUT_MS);
}

/**
 * Shown when an APTA-backed read fails for a reason the user cannot act on.
 * Deliberately not "no matches found": we did not learn that, and saying so
 * would read as an answer about their record.
 */
export const APTA_UNAVAILABLE_MESSAGE =
    "Your PTI stats are unavailable right now. Please try again in a moment.";
